import { createReducer, on } from '@ngrx/store';
import * as printActions from './print.actions';
import { printDataState } from './print.state';
import { PrintData } from '@interfaces/print.model';

export const printReducer = createReducer(
  printDataState,
  on(printActions.setPrintItemStateAction, (state, { provider, member }) => {
    const updatedSavedProviders = new Set([
      ...(state[member.id]?.savedProviders || []),
      provider,
    ]);
    return {
      ...state,
      [member.id]: {
        id: member.id,
        name: member.full_name,
        savedProviders: [...Array.from(updatedSavedProviders)],
      },
    };
  }),
  on(
    printActions.removePrintItemStateAction,
    (state, { providerId, member }) => {
      const memberSavedProviders = state[member.id]?.savedProviders || [];
      const updatedMemberSavedProviders = memberSavedProviders.filter(
        (provider: PrintData) => provider.id !== providerId
      );

      if (updatedMemberSavedProviders.length === 0) {
        const { [member.id]: _, ...newState } = state;
        return newState;
      }
      return {
        ...state,
        [member.id]: {
          id: member.id,
          name: member.name,
          savedProviders: updatedMemberSavedProviders,
        },
      };
    }
  ),
  on(printActions.clearAllPrintItemStateAction, (state) => {
    return {};
  })
);
